import { render } from "./RequestTypeManagement.vue?vue&type=template&id=6e1e6b12"
import script from "./RequestTypeManagement.vue?vue&type=script&lang=js"
export * from "./RequestTypeManagement.vue?vue&type=script&lang=js"

import "./RequestTypeManagement.vue?vue&type=style&index=0&id=6e1e6b12&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__